import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";

class AuthService {
  login(user) {
    //alert("login service");
    return axiosInstance
      .post("login", {
        username: user.username,
        password: user.password,
      })
      .then((response) => {
        if (response.status) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(user) {
    return axiosInstance
      .post("register", {
        enable_email_verification: 1,
        username: user.username,
        country: "BD",
      })
      .then((response) => {
        return response.data;
      });
  }

  otpVerification(user) {
    return axiosInstance.post("token-verification", user).then((response) => {
      return response.data;
    });
  }

  getDevices(user) {
    return axiosInstance.post("get-logged-in-devices", user).then((response) => {
      return response.data;
    });
  }

  getPriceList() {
    return axiosInstance.get("get-rates-by-plan-id").then((response) => {
      return response.data;
    });
  }

  getVpnServerDownloadList() {
    return axiosInstance.get("ips").then((response) => {
      return response.data;
    });
  }

  getServer(params) {
    let queryString = "";
    if (params) {
      queryString = "?" + params;
    }
    return axiosInstance.get("ips" + queryString, {
      headers: authHeader(),
    });
  }

  getCountry() {
    return axiosInstance.get("get-ip-countries", {
      headers: authHeader(),
    });
  }

  resentEmail(user) {
    return axiosInstance.post("resend-email-verification", user).then((response) => {
      return response.data;
    });
  }

  createPassword(user) {
    return axiosInstance.post("create-password-while-sign-up", user).then((response) => {
      return response.data;
    },
    {
      headers: authHeader(),
    }
  );
  }

  changePasswordWhileLogin(user) {
    return axiosInstance.post("change-password-while-login", user).then((response) => {
      return response.data;
    });
  }

  changeEmailWhileLogin(user) {
    return axiosInstance.post("change-email-while-login", user).then((response) => {
      return response.data;
    });
  }

  forgetotpVerification(user) {
    return axiosInstance.post("forget-password-token-verify", user).then((response) => {
      return response.data;
    });
  }

  otpResend(user) {
    return axiosInstance.post("otp-resend", user).then((response) => {
      return response.data;
    });
  }

  changePassword(user) {
    return axiosInstance.post(
      "change-forget-password",
      {
        username: user.username,
        token: user.token,
        password: user.password,
        password_confirmation: user.password_confirmation
      },
      {
        headers: authHeader(),
      }
    );
  }

  forgotPassword(user) {
    return axiosInstance.post("reset-password-token-request", user, {
    });
  }

  resetPassword(user, id, token) {
    return axiosInstance.post("reset-password", {
      id: id,
      token: token,
      password: user.password,
      password_confirmation: user.password_confirmation,
    });
  }

  wireguardUserConDownload(form) {
    return axiosInstance.post("wireguard-user-con-download", form, {
      headers: authHeader(),
    });
  }
}

export default new AuthService();
